import { render, staticRenderFns } from "./his-export.vue?vue&type=template&id=bce90756&scoped=true&"
import script from "./his-export.vue?vue&type=script&lang=ts&"
export * from "./his-export.vue?vue&type=script&lang=ts&"
import style0 from "./his-export.vue?vue&type=style&index=0&id=bce90756&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bce90756",
  null
  
)

export default component.exports